import styled from 'styled-components';
import { Link, LinkProps } from 'react-router-dom';

export const ButtonLink = styled(Link)<ButtonLinkProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	min-height: 40px;
	min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : '140px')};
	max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : 'unset')};
	padding: 8px 16px;
	color: #fff;
	background-color: ${props =>
		props.disabled
			? '#d9d9d9'
			: props.$backgroundColor
				? props.$backgroundColor
				: '#f47920'};
	border: none;
	outline: none;
	border-radius: 4px;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
	font-size: 14px;
	font-weight: 600;
	text-align: center;

	height: ${props => (props.$inline ? '40px' : 'fit-content')};
	padding: ${props => props.$inline && 'unset'};
	&:active {
		text-decoration: none;
	}
	&:hover {
		text-decoration: none;
		color: #fff;
	}
	&:focus {
		outline: none;
	}

	@media (max-width: 600px) {
		font-size: ${props => props.$buttonsize === 'small' && '14px'};
		min-width: ${props => props.$inline && '100px'};
	}
`;

export default ButtonLink;
interface ButtonLinkProps extends LinkProps {
	$backgroundColor?: string;
	children?: any;
	disabled?: boolean;
	$buttonsize?: 'small' | null;
	$inline?: boolean;
	$maxWidth?: string;
	$minWidth?: string;
}
